export default class OverseasBaseCostSetting {
    id: number;
    storeId: number;
    storeName: string;
    beginTime?: Date;
    endTime?: Date;
    whetherEffective: boolean;
    baseCost: number;
    baseSkuNums: number;
    exceedBaseSkuNums: number;
    exceedSkuCost: number;
    maxSkuCost: number;
    sackPrice: number;
    orderType: number;
}